<template>
    <div class="wrapper">
      <nav id="sidebar">
        <div class="sidebar-header logo bg-light">
            <img src="/static/favicon.png" alt="" width="50" height="30" class="img-fluid d-inline-block align-text-top ">
        </div>

        <ul class="list-unstyled components p-2" >
          <li :class="{active: 'dashboard' === activeModule}" @click="active('dashboard')">
            <router-link
              to="/dashboard"
              class="nav-link"
              href="#"
            >
              <activity-icon size="1x"/>
              Dashboard
            </router-link>
          </li>
          <li :class="{active: 'iv' === activeModule}" @click="active('iv')">
            <a href="#inventorySubmenu" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">Inventario</a>
            <ul class="collapse list-unstyled" id="inventorySubmenu">
              <li>
                  <router-link
                    to="/inventario"
                    class="nav-link"
                    href="#"
                  >
                    <box-icon size="1x" class="custom-class"></box-icon>
                    Producto
                  </router-link>
              </li>
              <li class="nav-item">
                  <router-link
                    to="/transferencia-inventario"
                    class="nav-link"
                    href="#"
                  >
                    <repeat-icon size="1x" class="custom-class"></repeat-icon>
                    Transferir inventario
                  </router-link>
                </li>
              <li class="nav-item">
                  <router-link
                    to="/ajuste-inventario"
                    class="nav-link"
                    href="#"
                  >
                    <crop-icon size="1x" />
                    Ajustar inventario
                  </router-link>
              </li>
              <li class="nav-item">
                  <router-link
                    to="/Codigos-de-retencion"
                    class="nav-link"
                    href="#"
                  >
                    <settings-icon size="1x" />
                    Códigos de retención
                  </router-link>
              </li>
              <li class="list-group">
                <a href="#inventoryInquiriesSubmenu" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                  <folder-icon size="1.1x"/> Consultas</a>
                  <ul class="collapse list-unstyled" id="inventoryInquiriesSubmenu">
                    <li>
                        <router-link
                          to="/inventario/consulta/stock"
                          class="nav-link"
                          href="#"
                        >
                        <folder-icon size="1x"/>
                          Stock de inventario
                        </router-link>
                    </li>
                  </ul>
              </li>
              <li class="list-group">
                  <router-link
                          to="/inventario/reportes"
                          class="nav-link"
                          href="#"
                        >
                        <folder-icon size="1x"/>
                          Reportes
                        </router-link>
                  <!-- <ul class="collapse list-unstyled" id="inventoryReportsSubmenu">
                    <li>
                        <router-link
                          to="/inventario/reportes"
                          class="nav-link"
                          href="#"
                        >
                        <folder-icon size="1x"/>
                          Otros
                        </router-link>
                    </li>
                  </ul> -->
              </li>
            </ul>
          </li>
          <li :class="{active: 'sl' === activeModule}" @click="active('sl')">
            <a href="#saleSubmenu" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">Ventas</a>
            <ul class="collapse list-unstyled" id="saleSubmenu">
                <li>
                    <router-link
                    to="/clientes"
                    class="nav-link"
                    href="#"
                  >
                    <user-icon size="1x" /> Clientes
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link
                    to="/Orden-de-venta"
                    class="nav-link"
                    href="#"
                  >
                    <user-check-icon size="1x" /> Entrada de venta
                  </router-link>
                </li>

                <li>
                    <router-link
                      to="/ventas/vendedores"
                      class="nav-link"
                      href="#"
                    >
                      <user-icon size="1x" /> Vendedores
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link
                    to="/ventas/promociones"
                    class="nav-link"
                    href="#"
                  >
                    <sliders-icon size="1x" /> Promociones
                  </router-link>
                </li>
                <li>
                    <router-link
                      to="/ventas/configuracion/codigos-de-documento"
                      class="nav-link"
                      href="#"
                    >
                      <sliders-icon size="1x" /> Consecutivos de venta
                    </router-link>
                </li>
                <li>
                    <router-link
                      to="/ventas/reportes"
                      class="nav-link"
                      href="#"
                    >
                    <folder-icon size="1x" /> Reportes
                    </router-link>
                </li>

            </ul>
          </li>
          <li :class="{active: 'pc' === activeModule}" @click="active('pc')">
            <a href="#purchaseSubmenu" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">Compras</a>
            <ul class="collapse list-unstyled" id="purchaseSubmenu">
              <li class="nav-item">
                <router-link
                  to="/proveedores"
                  class="nav-link"
                  href="#"
                >
                  <clipboard-icon size="1x" class="custom-class"></clipboard-icon>
                  Proveedores
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/orden-de-compra"
                  class="nav-link"
                  href="#"
                >
                  <shopping-cart-icon size="1x" class="custom-class"> </shopping-cart-icon>
                  Orden de compra
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/transaccion-de-compra"
                  class="nav-link"
                  href="#"
                >
                  <shopping-cart-icon size="1x" class="custom-class"> </shopping-cart-icon>
                  Entrada de recepción
                </router-link>
              </li>
              <li>
                <router-link
                  to="/compras/reportes"
                  class="nav-link"
                  href="#"
                >
                <folder-icon size="1x" /> Reportes
                </router-link>
              </li>
            </ul>
          </li>
          <li :class="{active: 'prod' === activeModule}" @click="active('prod')">
            <a href="#productionSubmenu" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">Producción</a>
            <ul class="collapse list-unstyled" id="productionSubmenu">
              <li>
                  <router-link
                    to="/componentes"
                    class="nav-link"
                    href="#"
                  >
                    <aperture-icon size="1x" />
                    Componentes
                  </router-link>
              </li>
              <li>
                  <router-link
                    to="/orden-de-fabricacion"
                    class="nav-link"
                    href="#"
                  >
                    <box-icon size="1x" />
                    Orden de fabricación
                  </router-link>
              </li>
              <li>
                  <router-link
                    to="/orden-de-produccion"
                    class="nav-link"
                    href="#"
                  >
                    <package-icon size="1x" />
                    Orden de producción
                  </router-link>
              </li>
              <li>
                  <router-link
                    to="/consumo-de-etiquetas"
                    class="nav-link"
                    href="#"
                  >
                    <package-icon size="1x" />
                    Consumo de etiquetas
                  </router-link>
              </li>
              <li>
                <router-link
                  to="/produccion/reportes"
                  class="nav-link"
                  href="#"
                >
                <folder-icon size="1x" /> Reportes
                </router-link>
              </li>
            </ul>
          </li>
          <li :class="{active: 'conf' === activeModule}" @click="active('conf')">
            <a href="#configSubmenu" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">Configuración</a>
            <ul class="collapse list-unstyled" id="configSubmenu">
              <li class="nav-item" >
                    <router-link
                      to="/administracion-de-usuario"
                      class="nav-link"
                      href="#"
                      :class="{'active': activePage==='user-management'}"
                    >
                      <users-icon size="1x" class="custom-class"></users-icon>
                      Usuarios
                    </router-link>
                  </li>
                  <li class="nav-item" >
                    <router-link
                      to="/impuestos"
                      class="nav-link"
                      href="#"
                      :class="{'active': activePage==='tax-management'}"
                    >
                      <percent-icon size="1x" />
                      Impuestos
                    </router-link>
                  </li>
                  <li class="nav-item" >
                    <router-link
                      to="/plan-de-impuestos"
                      class="nav-link"
                      href="#"
                      :class="{'active': activePage==='tax-schedule-management'}"
                    >
                      <percent-icon size="1x" />
                      Plan de impuestos
                    </router-link>
                  </li>
                  <li class="nav-item" >
                    <router-link
                      to="/tasa-de-cambio"
                      class="nav-link"
                      href="#"
                      :class="{'active': activePage==='rate-exchange-management'}"
                    >
                      <divide-icon size="1x" />
                      Tasa de cambio
                    </router-link>
                  </li>
                  <li class="nav-item" >
                    <router-link
                      to="/metodos-de-pago"
                      class="nav-link"
                      href="#"
                      :class="{'active': activePage==='payment-method'}"
                    >
                      <divide-icon size="1x" />
                      Método de pagos
                    </router-link>
                  </li>
            </ul>
          </li>
        </ul>
      </nav>

      <!-- Page Content  -->
      <div id="content">
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
          <div class="container-fluid" style="max-width: 100%">
            <button type="button" id="sidebarCollapse" class="btn btn-light btn-sm mr-4" @click="sidebarOnClick">
                <menu-icon size="1.6x" />
            </button>
            <form class="form-inline my-2 my-lg-0">
                <div class="dropdown">
                  <a class="dropdown-toggle mr-5" href="#" role="button" id="dropdownMenuButton" data-toggle="dropdown" aria-expanded="false">
                    {{ user.user_code }}
                  </a>
                  <div class="dropdown-menu dropdown-menu-right " aria-labelledby="navbarDropdown">
                     <a class="dropdown-item" href="#" @click="btnAccount_Click">Cambiar contraseña</a>
                    <div class="dropdown-divider"></div>

                    <a class="dropdown-item" href="#" @click="btnLogOut"><log-out-icon size="1x" class="text-danger"/>Cerrar sesión</a>

                  </div>
                </div>
            </form>


             <!-- <div class="mr-5">
              <ul class="navbar-nav">
                <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle mr-4" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-expanded="false">
                    {{user.user_code}}
                  </a>
                  <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item" href="#" @click="btnLogOut"><log-out-icon size="1x" class="text-danger"/>Cerrar sesión</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="#">Cambiar contraseña</a>
                  </div>
                </li>
              </ul>

             </div> -->
              <!-- <button class="btn btn-dark d-inline-block d-lg-none ml-auto" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <i class="fas fa-align-justify"></i>
              </button>
              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                  <ul class="nav navbar-nav ml-auto">
                      <li class="nav-item active">
                          <a class="nav-link" href="#">Page</a>
                      </li>
                      <li class="nav-item">
                          <a class="nav-link" href="#">Page</a>
                      </li>
                      <li class="nav-item">
                          <a class="nav-link" href="#">Page</a>
                      </li>
                      <li class="nav-item">
                          <a class="nav-link" href="#">Page</a>
                      </li>
                  </ul>
              </div> -->

          </div>

        </nav>
        <div class="container-sm " id="routerView">
          <router-view/>
        </div>

      </div>

    </div>
</template>
<script>
import { LogOutIcon, ShoppingCartIcon, BoxIcon, ClipboardIcon, RepeatIcon, CropIcon, UserIcon, UserCheckIcon, BookOpenIcon, UsersIcon, PercentIcon, DivideIcon, SlidersIcon, MenuIcon, ActivityIcon, SettingsIcon, FolderIcon, PackageIcon, ApertureIcon } from 'vue-feather-icons'
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    LogOutIcon,
    ShoppingCartIcon,
    BoxIcon,
    ClipboardIcon ,
    RepeatIcon,
    UserIcon,
    UserCheckIcon,
    BookOpenIcon,
    UsersIcon,
    PercentIcon,
    DivideIcon,
    CropIcon,
    SlidersIcon,
    MenuIcon,
    ActivityIcon,
    SettingsIcon,
    FolderIcon,
    PackageIcon,
    ApertureIcon,
  },
  data() {
    return {
      activeSidebar: false,
      activePage: "",
      activeModule: ""
    };
  },
  computed: {
    ...mapGetters("auth", ["loggedIn", "user"]),

  },
  methods: {
    ...mapActions("auth", ["logout"]),
    isMobile() {
      if (screen.width <= 760) {
        return true;
      }

      return false
    },
    toggleSidebar() {
      this.activeSidebar = !this.activeSidebar;
      this.sidebar.classList.toggle("active");
      this.mainContent.classList.toggle("active");
      this.mainHeader.classList.toggle("active");
    },
    btnLogOut() {
      this.logout()
    },
    active(module) {
      this.activeModule = module
    },
    sidebarOnClick() {
      $('#sidebar').toggleClass('active');
    },
    btnAccount_Click() {
      window.location.replace('/cuenta')
    }

  },
  watch: {
    $route(to, from) {
      if (this.isMobile()) {
        $('#sidebar').toggleClass('active');
      }
      this.activePage = to.name;
    }
  },
};
</script>

<style scoped>

  a,
  a:hover,
  a:focus {
      color: inherit;
      text-decoration: none;
      transition: all 0.3s;
  }

  .navbar {
      padding: 10px 10px;
      background: #fff;
      border: none;
      border-radius: 0;
      margin-bottom: 10px;
      box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
  }

  .navbar-btn {
      box-shadow: none;
      outline: none !important;
      border: none;
  }

  .wrapper {
      display: flex;
      width: 100%;
      align-items: stretch;
  }

  #sidebar {
      min-width: 250px;
      max-width: 250px;
      background: #8b0000c7;
      color: #fff;
      transition: all 0.3s;
  }

  #sidebar.active {
      margin-left: -250px;
  }

  #sidebar .sidebar-header {
      padding: 12px;
      background: #fff;
  }

  #sidebar ul.components {
      padding: 20px 0;
      border-bottom: 1px solid #8b0000c7;
  }

  #sidebar ul p {
      color: #fff;
      padding: 10px;
  }

  #sidebar ul li a {
      padding: 7px;
      font-size: 1.1em;
      display: block;
  }

  #sidebar ul li a:hover {
      color: #8b0000c7;
      background: #fff;
  }

  #content {
      width: 100%;
      min-height: 100vh;
      transition: all 0.3s;
  }


  #sidebar ul li.active>a,
  a[aria-expanded="true"] {
      font-weight: bold;
  }

  a[data-toggle="collapse"] {
      position: relative;
  }

  .dropdown-toggle::after {
      display: block;
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translateY(-50%);
  }

  ul ul a  {
      font-size: 0.9em !important;
      padding-left: 10px !important;
      background: #8b0000c7;
  }

  li.list-group ul {
    padding-left: 30px !important;
    background: #8b0000c7;
  }

  ul.CTAs {
      padding: 20px;
  }

  ul.CTAs a {
      text-align: center;
      font-size: 0.9em !important;
      display: block;
      border-radius: 5px;
      margin-bottom: 5px;
  }

  /* ---------------------------------------------------
      MEDIAQUERIES
  ----------------------------------------------------- */

  @media (max-width: 768px) {
      #sidebar {
          margin-left: -250px;
      }
      #sidebar.active {
          margin-left: 0;
      }
      #sidebarCollapse span {
          display: none;
      }
  }

  /* @media (min-width: 1920px) and (max-width: 1920px) {
    #routerView {
      max-width: 100% !important;
      padding-left: 2% !important;
      padding-right: 2% !important;

    }
  } */

  @media (min-width: 0px) and (max-width: 768px) {
    #routerView {
      max-width: 100% !important;
      padding: 0px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/Principal.vue